import { Link } from 'react-router-dom';

export default function WhatIsSection() {
  return (
    <section className="py-24 md:py-32 bg-gradient-to-b from-primary-600 to-primary-800">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Top Text */}
        <div className="mb-20">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-200/20 text-background-50/80 text-xs md:text-sm font-medium mb-6 border border-secondary-300/20">
            / About the System
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 max-w-3xl leading-[1.1]">
            What Is OOPBuy Spreadsheet
          </h2>
          <p className="text-background-50/70 text-base md:text-lg max-w-2xl mt-6 leading-relaxed">
            OOPBuy Spreadsheet is a structured shopping system based on organized spreadsheet product listings. Users select products directly from categorized sheets, orders are processed through an efficient agent workflow system — designed for transparency, speed, and cost efficiency.
          </p>
        </div>

        {/* Bottom: Two Column */}
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-start">
          {/* Left: System Screenshot */}
          <div className="lg:w-2/5 flex-shrink-0">
            <div className="relative rounded-xl overflow-hidden bg-background-100 aspect-square">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20modern%20spreadsheet%20interface%20showing%20product%20listings%20with%20organized%20columns%20and%20rows%20on%20light%20cream%20desktop%20screen%20minimalist%20UI%20design%20soft%20natural%20lighting%20editorial%20tech%20photography%20high%20detail&width=800&height=800&seq=about-system-screenshot-01&orientation=squarish"
                alt="OOPBuy Spreadsheet system interface"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>

          {/* Right: Content */}
          <div className="lg:w-3/5">
            <div className="text-[120px] md:text-[160px] font-heading font-bold text-background-50/10 leading-none mb-6">
              01
            </div>
            <div className="space-y-4">
              <p className="text-background-50/80 text-base leading-relaxed">
                The OOPBuy Spreadsheet system reimagines online sourcing by putting product data into clear, structured spreadsheet formats. Instead of navigating complex websites or dealing with slow agent responses, you browse organized product categories with all details visible upfront.
              </p>
              <p className="text-background-50/70 text-base leading-relaxed">
                Each product in the spreadsheet includes pricing, sizing, availability status, and direct links — giving you complete transparency before you commit. The agent workflow then handles order processing, payment verification, and shipping coordination.
              </p>
              <p className="text-background-50/60 text-base leading-relaxed">
                Whether you are a first-time buyer or an experienced sourcer, the spreadsheet system removes guesswork and provides a consistent, documentable process for every order.
              </p>
            </div>
            <Link
              to="/oopbuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 mt-8 px-6 py-3.5 rounded-full bg-background-50 hover:bg-background-100 transition-colors text-foreground-950 font-semibold text-sm whitespace-nowrap cursor-pointer"
            >
              Read Full Guide
              <i className="ri-arrow-right-line text-lg"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}